var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("collapse", { attrs: { title: "Información de la Solicitud" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-4" },
            [
              !_vm.isReadOnly
                ? _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-date-picker", {
                                staticClass: "w-100 custom-date-picker",
                                attrs: {
                                  clearable: false,
                                  "custom-error-msg": "El campo es requerido.",
                                  error: errors[0],
                                  label: "Fecha:",
                                  "max-date": new Date(),
                                  placeholder: "DD/MM/YYYY"
                                },
                                model: {
                                  value: _vm.date,
                                  callback: function($$v) {
                                    _vm.date = $$v
                                  },
                                  expression: "date"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4169156295
                    )
                  })
                : _vm.isReadOnly
                ? _c("label", [
                    _vm._v(" " + _vm._s(_vm._f("date")(_vm.date)) + " ")
                  ])
                : _vm._e()
            ],
            1
          )
        ]),
        _vm.isAmendmentRenewal
          ? _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("label", { staticClass: "data-label" }, [
                    _vm._v(
                      " ¿La Solicitud de Compra del servicio se realizó a través de MIPE? "
                    )
                  ]),
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ validated }) {
                            return [
                              _c("custom-radio", {
                                staticClass: "custom-radio",
                                attrs: {
                                  "custom-error-msg": "El campo es requerido.",
                                  disabled: _vm.isReadOnly,
                                  "is-inline": "",
                                  name: "isFromMipe",
                                  options: _vm.yesNoOptions
                                },
                                on: { input: _vm.onIsFromMipeChange },
                                model: {
                                  value: _vm.isFromMipe,
                                  callback: function($$v) {
                                    _vm.isFromMipe = $$v
                                  },
                                  expression: "isFromMipe"
                                }
                              }),
                              validated &&
                              ![true, false].includes(_vm.isFromMipe?.value)
                                ? _c("error", {
                                    attrs: {
                                      message: "El campo es requerido.",
                                      variant: "no-border"
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1676402896
                    )
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.isFromMipe?.value && _vm.isAmendmentRenewal
          ? _c(
              "div",
              { staticClass: "mt-3 bg-white rounded pb-3" },
              [
                _c(
                  "validation-observer",
                  { ref: "requestFormMipe" },
                  [
                    !_vm.isReadOnly
                      ? _c("div", { staticClass: "row m-1 py-3" }, [
                          _c(
                            "div",
                            { staticClass: "col" },
                            [
                              !_vm.isReadOnly
                                ? _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ errors }) {
                                            return [
                                              _c("custom-input", {
                                                attrs: {
                                                  "custom-error-msg":
                                                    "El campo es requerido.",
                                                  disabled: _vm.requestChecked,
                                                  error: errors[0],
                                                  icon:
                                                    "fal fa-search color-primary-2",
                                                  "left-icon": "",
                                                  placeholder:
                                                    "Número o Nombre de Compra de Servicio",
                                                  "prepend-icon-type": "success"
                                                },
                                                model: {
                                                  value: _vm.requestNumber,
                                                  callback: function($$v) {
                                                    _vm.requestNumber = $$v
                                                  },
                                                  expression: "requestNumber"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      932401044
                                    )
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-auto" },
                            [
                              _c("action-button", {
                                attrs: {
                                  disabled: _vm.requestChecked,
                                  i: "fal fa-search",
                                  text: "Buscar",
                                  variant: "success px-3"
                                },
                                on: { click: _vm.searchRequest }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    !_vm.isReadOnly
                      ? _c("custom-separator", {
                          staticClass: "my-2",
                          attrs: { text: "Resultados" }
                        })
                      : _vm._e(),
                    _vm.previousRequest
                      ? _c(
                          "custom-callout",
                          {
                            staticClass: "mx-3 pt-3",
                            attrs: {
                              "border-color": "#B5C3BC",
                              "has-toggle": false
                            }
                          },
                          [
                            _c("div", { staticClass: "row m-1 py-2" }, [
                              _c("div", { staticClass: "col-11" }, [
                                _c(
                                  "span",
                                  { staticClass: "body-2 text-gray" },
                                  [_vm._v(" Número de Compra de Servicio ")]
                                ),
                                _c(
                                  "div",
                                  { class: `body-1 font-16 color-black` },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.previousRequest) + " "
                                    )
                                  ]
                                )
                              ]),
                              !_vm.isReadOnly
                                ? _c("div", { staticClass: "col-1" }, [
                                    _c(
                                      "div",
                                      { class: `body-1 font-16 color-black` },
                                      [
                                        _c("check-box", {
                                          staticClass: "align-self-center mt-3",
                                          on: {
                                            input: _vm.onChangeRequestCheck
                                          },
                                          model: {
                                            value: _vm.requestChecked,
                                            callback: function($$v) {
                                              _vm.requestChecked = $$v
                                            },
                                            expression: "requestChecked"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm.warningMessage
                      ? _c(
                          "div",
                          {
                            staticClass: "alert alert-warning m-3",
                            attrs: { role: "alert" }
                          },
                          [
                            _c("i", { staticClass: "fas fa-bell mr-2" }),
                            _c("span", [_vm._v(_vm._s(_vm.warningMessage))]),
                            _vm.suggestedRequestNumber &&
                            _vm.suggestedRequestNumber !== _vm.requestNumber
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "btn-link p-0 ml-1",
                                    attrs: { type: "button" },
                                    on: { click: _vm.onClickSuggestedNumber }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.suggestedRequestNumber) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.isFromMipe?.value === false && _vm.isAmendmentRenewal
          ? _c(
              "div",
              [
                _c("validation-observer", { ref: "requestFormMipe" }, [
                  _c("div", { staticClass: "row py-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido.",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        label: "Número de PSF:"
                                      },
                                      model: {
                                        value: _vm.model.parentNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "parentNumber",
                                            $$v
                                          )
                                        },
                                        expression: "model.parentNumber"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1045449875
                          )
                        })
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.isAmendmentRenewal
          ? _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("label", { staticClass: "data-label" }, [
                    _vm._v(
                      " ¿El proceso de competencia se realizó a través de MIPE? "
                    )
                  ]),
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ validated }) {
                            return [
                              _c("custom-radio", {
                                staticClass: "custom-radio",
                                attrs: {
                                  "custom-error-msg": "El campo es requerido.",
                                  disabled: _vm.isReadOnly,
                                  "is-inline": "",
                                  name: "isCompetitionProcessFromMipe",
                                  options: _vm.yesNoOptions
                                },
                                on: {
                                  input: _vm.isCompetitionProcessFromMipeChange
                                },
                                model: {
                                  value: _vm.isCompetitionProcessFromMipe,
                                  callback: function($$v) {
                                    _vm.isCompetitionProcessFromMipe = $$v
                                  },
                                  expression: "isCompetitionProcessFromMipe"
                                }
                              }),
                              validated &&
                              ![true, false].includes(
                                _vm.isCompetitionProcessFromMipe?.value
                              )
                                ? _c("error", {
                                    attrs: {
                                      message: "El campo es requerido.",
                                      variant: "no-border"
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3573244027
                    )
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.isCompetitionProcessFromMipe?.value && _vm.isAmendmentRenewal
          ? _c(
              "div",
              { staticClass: "mt-3 bg-white rounded pb-3" },
              [
                _c(
                  "validation-observer",
                  { ref: "competitionProcessFormMipe" },
                  [
                    !_vm.isReadOnly
                      ? _c("div", { staticClass: "row m-1 py-3" }, [
                          _c(
                            "div",
                            { staticClass: "col" },
                            [
                              !_vm.isReadOnly
                                ? _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ errors }) {
                                            return [
                                              _c("custom-input", {
                                                attrs: {
                                                  "custom-error-msg":
                                                    "El campo es requerido.",
                                                  disabled:
                                                    _vm.competitionRequestChecked,
                                                  error: errors[0],
                                                  icon:
                                                    "fal fa-search color-primary-2",
                                                  "left-icon": "",
                                                  placeholder:
                                                    "Escriba Número de Pliego",
                                                  "prepend-icon-type": "success"
                                                },
                                                model: {
                                                  value: _vm.announcementNumber,
                                                  callback: function($$v) {
                                                    _vm.announcementNumber = $$v
                                                  },
                                                  expression:
                                                    "announcementNumber"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1924560335
                                    )
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-auto" },
                            [
                              _c("action-button", {
                                attrs: {
                                  disabled: _vm.competitionRequestChecked,
                                  i: "fal fa-search",
                                  text: "Buscar",
                                  variant: "success px-3"
                                },
                                on: { click: _vm.searchAnnouncement }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    !_vm.isReadOnly
                      ? _c("custom-separator", {
                          staticClass: "my-2",
                          attrs: { text: "Resultados" }
                        })
                      : _vm._e(),
                    _vm.previousAnnouncementNumber
                      ? _c(
                          "custom-callout",
                          {
                            staticClass: "mx-3 pt-3",
                            attrs: {
                              "border-color": "#B5C3BC",
                              "has-toggle": false
                            }
                          },
                          [
                            _c("div", { staticClass: "row m-1 py-2" }, [
                              _c("div", { staticClass: "col-11" }, [
                                _c(
                                  "span",
                                  { staticClass: "body-2 text-gray" },
                                  [_vm._v(" Número de Pliego ")]
                                ),
                                _c(
                                  "div",
                                  { class: `body-1 font-16 color-black` },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.previousAnnouncementNumber) +
                                        " "
                                    )
                                  ]
                                )
                              ]),
                              !_vm.isReadOnly
                                ? _c("div", { staticClass: "col-1" }, [
                                    _c(
                                      "div",
                                      { class: `body-1 font-16 color-black` },
                                      [
                                        _c("check-box", {
                                          staticClass: "align-self-center mt-3",
                                          on: {
                                            input:
                                              _vm.onChangeCompetitionRequestCheck
                                          },
                                          model: {
                                            value:
                                              _vm.competitionRequestChecked,
                                            callback: function($$v) {
                                              _vm.competitionRequestChecked = $$v
                                            },
                                            expression:
                                              "competitionRequestChecked"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }